<div class="container-fluid">

  <h4 id="upper"> Président coopérative </h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>
            <!--  -->
            <div class="d-flex align-items-center gap-3 flex-wrap">
              <label for="categorie" class="form-label">Rechercher</label>
              <div>
                <label class="d-inline-flex align-items-center">
                  <input title="Rechercher par nom, prénom, email ou téléphone" type="text" [(ngModel)]="searchTerm"
                    (input)="filterBySearchTerm()" class="form-control" id="searchMembre" placeholder="" />

                </label>
              </div>

              <a (click)="openModal()" title="Cliquez ici pour ajouter un certificat de decès"
                style="background-color:#578D63 ;" href="javascript:void(0);" class="btn btn-success mb-2" id="gras">
                <i class="mdi mdi-plus me-2"></i> Ajouter
              </a>&nbsp;
            </div>


          </div>
          <div class="row mb-md-2">


            <!-- End search -->
          </div>
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col" class="ps-0">Nom</th>
                  <th scope="col">Prénom</th>
                  <th scope="col">Email</th>

                  <th scope="col" class="text-center">Coopérative</th>
                  <th scope="col" class="text-center">Statut</th>
                  <th scope="col" colspan="3" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item of paginatedItems" [ngClass]="{'table-danger': item?.statut === 'suspens'}">
                  <th scope="row" class="ps-0 fw-medium">
                    <span class="table-link1 text-truncate d-block">{{ item?.nom }} &nbsp;</span>
                  </th>
                  <td>
                    <span class="table-link1 text-truncate d-block">{{ item?.prenom }}</span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block">{{ item?.email }}</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">{{ item?.cooperative?.nom || ""}} &nbsp;</span>
                  </td>
                  <td class="text-center fw-medium">
                    <span class="table-link1 text-truncate d-block">
                      {{ getLibelleStatut(item?.statut) }}
                    </span>
                  </td>
                  <td>
                    <!-- Modifier (toujours disponible) -->
                    <a (click)="editOpenModal(item)" style="cursor: pointer;" class="me-3 text-primary"
                      title="Cliquez ici pour modifier un administrateur">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>

                    <!-- Valider (uniquement si en attente) -->
                    <a *ngIf="item.statut==='pending'" (click)="validerAdministrateur(item)" style="cursor: pointer;"
                      class="me-3 text-success" title="Cliquez ici pour valider un administrateur">
                      <i class="pi pi-check-circle" style="font-size: 1rem"></i>
                    </a>

                    <!-- Suspendre (uniquement si actif) -->
                    <a *ngIf="item.statut==='valide'" (click)="prepareSuspend(item)" style="cursor: pointer;"
                      class="me-3 text-info" title="Cliquez ici pour suspendre un administrateur">
                      <i class="pi pi-times-circle" style="font-size: 1rem"></i>
                    </a>

                    <!-- Réactiver (uniquement si suspendu) -->
                    <a *ngIf="item.statut==='suspens'" (click)="reactiverAdministrateur(item)" style="cursor: pointer;"
                      class="me-3 text-warning" title="Cliquez ici pour réactiver un administrateur">
                      <i class="pi pi-refresh" style="font-size: 1rem"></i>
                    </a>
                    <a *ngIf="item.statut==='pending'" style="cursor: pointer;" (click)="prepareReject(item)"
                      class="me-3 text-danger" title="Rejeter">
                      <i class="pi pi-times" style="font-size:1rem"></i>
                    </a>
                    <!-- Supprimer (toujours disponible) -->
                    <a (click)="confirmSuppression(item)" href="javascript:void(0);" class="text-danger"
                      title="Cliquez ici pour retirer un administrateur">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>

                </tr>

              </tbody>
            </table>
          </div>

        </div>
        <div class="d-flex justify-content-center" *ngIf="isLoading === true">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Chargement en cours...</h5>
                <div class="loader4"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>
    </div>
  </div>


</div>



<p-dialog header="Motif de suspension" [modal]="true" [(visible)]="displaySuspendDialog" [style]="{ width: '25rem' }">
  <div class="d-flex flex-column align-items-center">
    <div class="col-12 col-md-8 text-center">
      <textarea class="form-control" id="reason" rows="4" cols="30" [(ngModel)]="suspendReason" required
        placeholder="Entrez le motif de suspension"></textarea>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="Enregistrer" (click)="suspendAdmin()" />
  </div>
</p-dialog>

<p-dialog header="Motif de rejet" [modal]="true" [(visible)]="displayRejectDialog" [style]="{ width: '25rem' }">
  <div class="d-flex flex-column align-items-center">
    <div class="col-12 col-md-8 text-center">
      <textarea class="form-control" id="reason" rows="4" cols="30" [(ngModel)]="rejectReason" required
        placeholder="Entrez le motif de rejet"></textarea>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-2 mt-3">
    <p-button label="Enregistrer" (click)="onConfirmReject()" />
  </div>
</p-dialog>


<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>